import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncodingService {

  base64DecodeXOR(encodedStr, key) {
    // Base64 decode
    const decodedStr = atob(encodedStr);

    // XOR decode with the key
    const xorKey = key.toString();
    let result = '';

    for (let i = 0; i < decodedStr.length; i++) {
      const decodedChar = decodedStr.charCodeAt(i);
      const keyChar = xorKey.charCodeAt(i % xorKey.length);
      const xorChar = decodedChar ^ keyChar; // XOR operation
      result += String.fromCharCode(xorChar);
    }
    return result;
  }

  base64EncodeXOR(str: string, key: number): string {
    const xorKey = key.toString();
    let result = '';

    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i);
      const keyCharCode = xorKey.charCodeAt(i % xorKey.length);
      const xorCharCode = charCode ^ keyCharCode; // XOR operation
      result += String.fromCharCode(xorCharCode);
    }

    // Base64 encode the result
    return btoa(result);
  }
}
